package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class DiagnosisSettingStatus(private val literal: String) : IEnumType {
	正常("正常"),
	已删除("已删除");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "diagnosis_setting_status"}
	override fun getLiteral(): String {return literal}
}
